export class SC_ServiceFileType {
    static readonly NULL = 0;
    static readonly SIGNATURE = 1;
    static readonly QC_BEFORE = 2;
    static readonly QC_AFTER = 3;
    static readonly SUPPLEMENTAL = 4;
    static readonly REPORT = 5;
    static readonly CREW_PICTURE = 6;

    constructor(private type: number = SC_ServiceFileType.NULL) { }

    static fromAPI(apiValue: number): SC_ServiceFileType {
        switch (apiValue) {
            case SC_ServiceFileType.SIGNATURE:
                return new SC_ServiceFileType(SC_ServiceFileType.SIGNATURE);
            case SC_ServiceFileType.QC_BEFORE:
                return new SC_ServiceFileType(SC_ServiceFileType.QC_BEFORE);
            case SC_ServiceFileType.QC_AFTER:
                return new SC_ServiceFileType(SC_ServiceFileType.QC_AFTER);
            case SC_ServiceFileType.SUPPLEMENTAL:
                return new SC_ServiceFileType(SC_ServiceFileType.SUPPLEMENTAL);
            case SC_ServiceFileType.REPORT:
                return new SC_ServiceFileType(SC_ServiceFileType.REPORT);
            case SC_ServiceFileType.CREW_PICTURE:
                return new SC_ServiceFileType(SC_ServiceFileType.CREW_PICTURE);
            default:
                return new SC_ServiceFileType();
        }
    }

    is(type: number): boolean {
        return this.type === type;
    }

    toAPI(): number {
        return this.type;
    }

    clone(): SC_ServiceFileType {
        return new SC_ServiceFileType(this.type);
    }

    /**
     * Merges another ServiceFileType object into this one, replacing null fields
     */
    merge(other: SC_ServiceFileType): SC_ServiceFileType {
        if (other.type !== SC_ServiceFileType.NULL) {
            this.type = other.type;
        }

        return this;
    }

    static readonly fileTypes: { key: number; display: string }[] = [
        { key: SC_ServiceFileType.NULL, display: "Not Set" },
        { key: SC_ServiceFileType.SIGNATURE, display: "Signature" },
        { key: SC_ServiceFileType.QC_BEFORE, display: "QC Image Before" },
        { key: SC_ServiceFileType.QC_AFTER, display: "QC Image After" },
        { key: SC_ServiceFileType.SUPPLEMENTAL, display: "Supplemental Material" },
        { key: SC_ServiceFileType.REPORT, display: "Quality Control" },
        { key: SC_ServiceFileType.CREW_PICTURE, display: "Crew Picture" },
    ];

    static get imageFileTypes(): { key: number; display: string }[] {
        return SC_ServiceFileType.fileTypes.filter(({key}) => (new SC_ServiceFileType(key)).isPicture);
    }

    toString(): string {
        switch (this.type) {
            case SC_ServiceFileType.SIGNATURE:
                return "Signature";
            case SC_ServiceFileType.QC_BEFORE:
                return "QC Image Before";
            case SC_ServiceFileType.QC_AFTER:
                return "QC Image After";
            case SC_ServiceFileType.SUPPLEMENTAL:
                return "Supplemental Material";
            case SC_ServiceFileType.REPORT:
                return "Quality Control";
            case SC_ServiceFileType.CREW_PICTURE:
                return "Crew Picture";
            default:
                return "Not Set";
        }
    }

    get isPicture(): boolean {
        return this.type === SC_ServiceFileType.QC_BEFORE || this.type === SC_ServiceFileType.QC_AFTER || this.type === SC_ServiceFileType.CREW_PICTURE;
    }
}
